<template>
  <div class="w100 Contenido">
    <Titulo seccion="Análisis de Agua Útil" icon="water"/>
    <Descripcion>A través de análisis georreferenciados se registra la recarga hídrica del perfil del lote a través de la cuantificación de agua útil.</Descripcion>
    <Tabla nombre="Aguas" :columnas="columnasTabla"/>
    <BotonVerMapa route="/vermapa" />
  </div>
</template>

<script>
import { ColumnasTabla } from "../../Auxiliares/Enums";

export default {
  name: "Aguas",
  data() {
    return {
      columnasTabla: [ ColumnasTabla.Productor, ColumnasTabla.Establecimiento, ColumnasTabla.Localidad ]
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../Css/Componentes.scss";
@import "../../Css/Globales.css";
@import "../../Css/Secciones/Tabla.css";
</style>
